export const defaultSearchSettings = {
  keys: ['title'],
  threshold: 0.3,
}

export const defaultSelectedComparator = (option, value) => {
  if (Array.isArray(value)) {
    return Boolean(value.find((candidate) => candidate.id === option.id))
  }

  return option.id === value.id
}
